import {useState,useEffect} from 'react'

import StarboxIcon from '../starboxIcon.svg'
import {useNavigate} from 'react-router-dom'

import icosearch from '../img/ico-search.svg';


import starboxLogo2 from '../img2026/starboxLogo2.avif';

import strings from '../strings.js'
import { SendMessage, socket } from '../App.js';
import localForage from "localforage";


export function TableNo( {skin, socketId, stateVer, setTableNo, setLang, lang, setStatePlaylist, setStatePlaylistYT, setStateRec, setStatePlaybackSong, setStateYouTube, stateQrLock} ) {

    const navigate = useNavigate();
    const [tableNoErrorEN, setTableNoErrorEN] = useState(strings.en.enterTableNo);
    const [tableNoErrorCN, setTableNoErrorCN] = useState(strings.cn.enterTableNo);
    const [tableNoInput, setTableNoInput] = useState("");


    async function goInApp() {
        if (JSON.parse(localStorage.getItem("serverHere"))){
            if (tableNoInput === "147") {
                const roomValue = await localForage.getItem("room");
                console.log(roomValue)
                if (roomValue !== 602307140100) {
                    await localForage.setItem("table", parseInt(tableNoInput));
                    SendMessage('[{"type":"MSG_REQ"}]');
                    navigate("/admin", { replace: true });
                }
                return;
            } else if (tableNoInput === "520") {
                const roomValue = await localForage.getItem("room");
                if (roomValue === 602307140100) {
                    await localForage.setItem("table", 147);
                    SendMessage('[{"type":"MSG_REQ"}]');
                    navigate("/admin", { replace: true });
                }
                return;
            }
            else {
                try {
                    if(stateQrLock) {
                        setTableNoErrorCN(strings.cn.qrHiddenError)
                        setTableNoErrorEN(strings.en.qrHiddenError)
                        return;
                    }
                    if(JSON.parse(localStorage.getItem("state")).tables["t" + tableNoInput]["locked"]) {
                        setTableNoErrorCN(strings.cn.roomLockedError)
                        setTableNoErrorEN(strings.en.roomLockedError)
                        return;
                    }
                    setTableNo(parseInt(tableNoInput))
                    localForage.setItem("table", parseInt(tableNoInput))
                    setStatePlaylist(JSON.parse(localStorage.getItem("state")).tables["t" + parseInt(tableNoInput)]["playlist"].map(f=> f.songcode).toString());
                    setStatePlaylistYT(JSON.parse(localStorage.getItem("state")).tables["t" + parseInt(tableNoInput)]["playlist"].map(f=> f.ytname));
                    setStateYouTube(JSON.parse(localStorage.getItem("state")).youtube);
                    switch(stateVer)
                    {
                        case "danji":
                            setStateRec(JSON.parse(localStorage.getItem("state")).tables["t" + parseInt(tableNoInput)]["rec"].map(f=> f.songcode).toString());
                            break;
                        case "dating":
                            setStateRec(JSON.parse(localStorage.getItem("state")).tables["t" + parseInt(tableNoInput)]["rec"].map(f=> f.songcode).toString());
                            try{
                                setStatePlaybackSong(JSON.parse(localStorage.getItem("state")).playbackSong.toString());
                            }
                            catch{}
                            break;
                    }
                    navigate("/home", { replace: true });
                    return;
                }
                catch {
                    setTableNoErrorCN(strings.cn.roomNotExistError)
                    setTableNoErrorEN(strings.en.roomNotExistError)
                    return;
                }
            }
        }
        else {
            setTableNoErrorCN(strings.cn.roomNotOnlineError)
            setTableNoErrorEN(strings.en.roomNotOnlineError)
            return;
        }
    }

    function displayMessage(message){
        const div = document.createElement("div");
        div.textContent = message;
        document.getElementById("message-container").append(div);
    }
    

return (
<>
    { socket.id!=="" && (
    <>

        {skin === 0 && (
        <div className="topCentreIcon">
            <img
            src={StarboxIcon}
            alt="Starbox"
            />
        </div>
        )}
        {skin === 1 && (
        <div className="topCentreIcon" style={{paddingLeft: 'calc(4vw)', paddingRight: 'calc(4vw)', paddingTop: 'calc(4vw)', paddingBottom: 'calc(4vw)', flexGrow: '7'}}>
            <img
            src={starboxLogo2}
            alt="Starbox"
            style={{maxWidth:'none', maxHeight:'calc(70vh)', width:'default', maxWidth: '100%',  objectFit:'contain', height:'100%', width:'100%'}}
            />
        </div>
        )}

        <div className="tableNoOtherStuff">
            <div className="pleaseEnterTableNo" style={skin === 1 ? { color: '#ffffff', fontWeight: 'bold' } : {}}>
            {lang ? tableNoErrorCN : tableNoErrorEN}
            </div>



            <div className = "tableNoSearch">
                <img className = "tableNoSearchIcon"
                    src={icosearch}
                    alt="search"
                />
                <input
                    inputMode="numeric"
                    type="number"
                    pattern="[0-9]*"
                    placeholder=""
                    value={tableNoInput}
                    onChange={(e) => setTableNoInput(e.target.value)}
                />

                <button className="tableNoSearchClose" type="button"
                        alt="enter"
                        onClick={(e) => {e.preventDefault(); goInApp();}}
                        style={skin === 1 ? { backgroundImage: 'linear-gradient(360deg, rgba(255, 102, 0, 1) 0%, rgba(255, 187, 89, 1) 100%)', 
          fontWeight: 'bold' } : {}}       
                >{lang ? strings.cn.enter : strings.en.enter}
                </button>

            </div>




            <div className="otherLangTable">
<div 
  className={`otherLangTableNo ${!lang ? 'active' : ''}`}
  onClick={(e) => { e.preventDefault(); setLang(false); }}
>
  English
</div>

<div 
  className={`otherLangTableNo ${lang ? 'active' : ''}`}
  onClick={(e) => { e.preventDefault(); setLang(true); }}
>
  中文
</div>
            </div>
        </div>
    </>
    )}
    </>
)}
